webpackJsonp([0],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(63);

__webpack_require__(494);

__webpack_require__(495);

var _preview = __webpack_require__(496);

var _preview2 = _interopRequireDefault(_preview);

var _favicon = __webpack_require__(497);

var _favicon2 = _interopRequireDefault(_favicon);

var _ContactForm = __webpack_require__(499);

var _TextInput = __webpack_require__(498);

var _EmailInput = __webpack_require__(504);

var _TextArea = __webpack_require__(506);

var _undraw_hiring_cyhs = __webpack_require__(508);

var _undraw_hiring_cyhs2 = _interopRequireDefault(_undraw_hiring_cyhs);

var _undraw_wallet_aym = __webpack_require__(509);

var _undraw_wallet_aym2 = _interopRequireDefault(_undraw_wallet_aym);

var _undraw_QA_engineers_dg5p = __webpack_require__(510);

var _undraw_QA_engineers_dg5p2 = _interopRequireDefault(_undraw_QA_engineers_dg5p);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_PureComponent) {
    _inherits(Home, _PureComponent);

    function Home() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Home);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Home.__proto__ || Object.getPrototypeOf(Home)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return _react2.default.createElement(
                'div',
                { style: {
                        display: 'flex',
                        flexFlow: 'row wrap',
                        alignItems: 'flex-start',
                        justifyContent: 'space-around'
                    } },
                _react2.default.createElement(
                    _reactStatic.Head,
                    null,
                    _react2.default.createElement(
                        'title',
                        null,
                        'Asbestkrachten | wij zoeken mensen!'
                    ),
                    _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
                    _react2.default.createElement('link', { rel: 'canonical', href: ' https://asbestkrachten.nl' }),
                    _react2.default.createElement('meta', { property: 'og:url', content: 'https://www.asbestkrachten.nl/' }),
                    _react2.default.createElement('meta', { property: 'og:title', content: 'Asbestkrachten | wij zoeken mensen!' }),
                    _react2.default.createElement('meta', { name: 'description', property: 'og:description',
                        content: 'Zoek je een baan? Wij leiden je op en zorgen dat je aan het werk komt!' }),
                    _react2.default.createElement('meta', { property: 'og:image', content: _preview2.default }),
                    _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: _favicon2.default })
                ),
                _react2.default.createElement(
                    'section',
                    { id: 'flow' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'WIJ ZOEKEN JOU!'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wil jij werken in een vak waar je trots op kan zijn? Wij zijn per direct op zoek naar mensen die asbest willen sanereren.'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'two-lists' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Waar moet je over beschikken?'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Een rijbewijs.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'De mentaliteit om iedere dag op tijd te komen.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Je moet niet bang zijn voor hoogte of kleine ruimtes.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Je moet de Nederlandse taal spreken en begrijpen.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Je moet graag met je handen werken.'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'h3',
                                null,
                                'Wat bieden wij jou?'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Een salaris conform de bouw CAO.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Indien nodig alle opleidingen'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Begeleiding.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Alle noodzakelijke spullen om veilig te werken.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Werk bij de beste bedrijven van Nederland!'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h1',
                        null,
                        'De eerste 3 dagen'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement('img', { src: _undraw_hiring_cyhs2.default, style: {
                                float: 'left',
                                margin: '1em',
                                maxHeight: 150,
                                maxWidth: '40vw'
                            } }),
                        'Asbest verwijderen is een beroep. Je werkt iedere dag met asbesthoudende toepassingen. Dit doe je natuurlijk niet onbeschermd. Je krijgt dan ook persoonlijke beschermingsmiddelen zoals een masker. Dit masker heb je in bruikleen. Het wordt nooit jouw masker. Maar je moet er natuurlijk wel goed voor zorgen! Om zeker te weten dat je het masker hebt dat bij jouw gezicht past en dus heel goed aansluit op je gezicht moet er een face-fit-test gedaan worden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'De training voor DAV-1 duurt 1 of 2 dagen, gevolgd door een examen van 1 dag.'
                    ),
                    _react2.default.createElement(
                        'h1',
                        null,
                        'De volgende 7 dagen'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement('img', { src: _undraw_QA_engineers_dg5p2.default, style: {
                                float: 'right',
                                margin: '1em',
                                maxHeight: 150,
                                maxWidth: '40vw'
                            } }),
                        'Nadat je het examen hebt gehaald word je aan een mentor gekoppeld, krijg je het certificaat DAV-1 en worden er persoonlijke beschermingsmiddelen voor je besteld. Veel hoef je dus zelf niet meer te doen, maar je moet nog wel door een medische keuring. De keuring is nodig om er zeker van te zijn dat je fysiek in staat bent om met een masker op te werken.'
                    ),
                    _react2.default.createElement(
                        'h1',
                        null,
                        'Daarna: Aan het werk!'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement('img', { src: _undraw_wallet_aym2.default, style: {
                                float: 'left',
                                margin: '1em',
                                maxHeight: 150,
                                maxWidth: '40vw'
                            } }),
                        'Als je bent opgeleid dan kun je nog niet \u2018echt\u2019 saneren. Saneren moet je leren. Daarom krijg je een mentor toegewezen. Je leert het vak in de praktijk. De DTA (je leidinggevende) legt je uit wat je moet doen. De mentor komt af en toe langs om te kijken hoe het gaat en of er nog bijzonderheden zijn.'
                    ),
                    _react2.default.createElement(
                        _ContactForm.ContactForm,
                        null,
                        _react2.default.createElement(
                            'h2',
                            null,
                            'Stuur een bericht'
                        ),
                        _react2.default.createElement(_TextInput.TextInput, { required: true, name: 'contact-name', label: 'Naam', message: 'Bij voorkeur voor- en achternaam',
                            autoComplete: 'name' }),
                        _react2.default.createElement(_EmailInput.EmailInput, { required: true, name: 'contact-email', label: 'e-Mail',
                            message: 'Uw e-mailadres wordt alleen gebruikt om met u in contact te komen' }),
                        _react2.default.createElement(_TextInput.TextInput, { required: true, type: 'tel', name: 'contact-phone', label: 'Telefoonnummer', autoComplete: 'tel',
                            message: 'Uw telefoonnummer wordt alleen gebruikt om met u in contact te komen' }),
                        _react2.default.createElement(_TextArea.TextArea, { name: 'contact-message', label: 'Bericht' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Home;
}(_react.PureComponent);

exports.default = Home;

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/preview.714d7529.jpg";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/favicon.15e6d78c.ico";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextInput = __webpack_require__(502);

Object.keys(_TextInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TextInput[key];
    }
  });
});

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContactForm = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _SubmitButton = __webpack_require__(500);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactForm = exports.ContactForm = function (_PureComponent) {
    _inherits(ContactForm, _PureComponent);

    function ContactForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ContactForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            success: false,
            failure: false,
            pending: false
        }, _this.submit = function (event) {
            event.preventDefault();

            var target = event.target;

            var formData = new FormData(target);

            formData.append('contact-subject', 'Asbestkrachten: nieuwe aanmelding');

            var urlSearchParams = new URLSearchParams(formData);
            var options = {
                method: 'post',
                body: urlSearchParams,
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                })
            };

            _this.setState({
                success: false,
                failure: false,
                pending: true
            });

            fetch('/PHPMailer/asbestkrachten_contact_form.php', options).then(function (response) {
                if (response.ok) {
                    _this.setState({
                        success: true,
                        failure: false,
                        pending: false
                    });

                    target.reset();
                } else {
                    _this.setState({
                        failure: true,
                        success: false,
                        pending: false
                    });
                }
            }).catch(function (error) {
                console.error(error);

                _this.setState({
                    failure: true,
                    success: false,
                    pending: false
                });
            });

            return false;
        }, _this.render = function () {
            var _this$props = _this.props,
                style = _this$props.style,
                _this$props$buttonMes = _this$props.buttonMessage,
                buttonMessage = _this$props$buttonMes === undefined ? 'Verzend' : _this$props$buttonMes;
            var _this$state = _this.state,
                success = _this$state.success,
                failure = _this$state.failure,
                pending = _this$state.pending;


            var _buttonMessage = success ? 'Uw bericht is verstuurd!' : pending ? 'Uw bericht is onderweg...' : failure ? 'Bericht is niet verzonden door een fout!' : buttonMessage;

            var buttonStyle = {
                backgroundColor: failure ? 'red' : undefined
            };

            return _react2.default.createElement(
                'form',
                { id: 'contact-form', onSubmitCapture: _this.submit, style: style },
                _this.props.children,
                _react2.default.createElement(_SubmitButton.SubmitButton, { value: _buttonMessage, style: buttonStyle })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return ContactForm;
}(_react.PureComponent);

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SubmitButton = __webpack_require__(501);

Object.keys(_SubmitButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SubmitButton[key];
    }
  });
});

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubmitButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ContainedButton2 = __webpack_require__(186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubmitButton = exports.SubmitButton = function (_ContainedButton) {
    _inherits(SubmitButton, _ContainedButton);

    function SubmitButton() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SubmitButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubmitButton.__proto__ || Object.getPrototypeOf(SubmitButton)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return _react2.default.createElement('input', _extends({}, _this.props, { type: 'submit' }));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SubmitButton;
}(_ContainedButton2.ContainedButton);

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(503);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInput = exports.TextInput = function (_PureComponent) {
    _inherits(TextInput, _PureComponent);

    function TextInput() {
        _classCallCheck(this, TextInput);

        var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).apply(this, arguments));

        _this.onChange = function (_ref) {
            var target = _ref.target;
            var value = target.value;


            _this.setState({
                value: value,
                valid: value === '' || target.checkValidity()
            });

            _this.props.onChange && _this.props.onChange(value);
        };

        _this.render = function () {
            var _this$props = _this.props,
                type = _this$props.type,
                label = _this$props.label,
                message = _this$props.message,
                rest = _objectWithoutProperties(_this$props, ['type', 'label', 'message']);

            var _this$state = _this.state,
                value = _this$state.value,
                valid = _this$state.valid;


            return _react2.default.createElement(
                'div',
                { className: 'form-element ' + (!valid ? 'form-element-invalid' : ''), 'data-content': !!value },
                _react2.default.createElement(
                    'label',
                    { className: 'form-element-label' },
                    _react2.default.createElement(
                        'span',
                        { className: 'form-element-label-text' },
                        label
                    ),
                    _react2.default.createElement('input', _extends({ type: type }, rest, { className: 'form-element-input', onChange: _this.onChange }))
                ),
                message && _react2.default.createElement(
                    'span',
                    { className: 'form-element-message' },
                    message
                )
            );
        };

        _this.state = {
            value: '',
            valid: true
        };
        return _this;
    }

    return TextInput;
}(_react.PureComponent);

TextInput.defaultProps = {
    type: 'text'
};

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmailInput = __webpack_require__(505);

Object.keys(_EmailInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EmailInput[key];
    }
  });
});

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmailInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _TextInput2 = __webpack_require__(498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailInput = exports.EmailInput = function (_TextInput) {
    _inherits(EmailInput, _TextInput);

    function EmailInput() {
        _classCallCheck(this, EmailInput);

        return _possibleConstructorReturn(this, (EmailInput.__proto__ || Object.getPrototypeOf(EmailInput)).apply(this, arguments));
    }

    return EmailInput;
}(_TextInput2.TextInput);

EmailInput.defaultProps = _extends({}, _TextInput2.TextInput.dealtProps, {
    autoComplete: 'email',
    type: 'email'
});

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextArea = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(507);

var _TextInput2 = __webpack_require__(498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextArea = exports.TextArea = function (_TextInput) {
    _inherits(TextArea, _TextInput);

    function TextArea() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TextArea);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            var _this$props = _this.props,
                label = _this$props.label,
                message = _this$props.message,
                initialValue = _this$props.initialValue,
                rest = _objectWithoutProperties(_this$props, ['label', 'message', 'initialValue']);

            var _this$state = _this.state,
                value = _this$state.value,
                valid = _this$state.valid;


            return _react2.default.createElement(
                'div',
                { className: 'form-element ' + (!valid ? 'form-element-invalid' : ''), 'data-content': !!value },
                _react2.default.createElement(
                    'label',
                    { className: 'form-element-label' },
                    _react2.default.createElement(
                        'span',
                        { className: 'form-element-label-text' },
                        label
                    ),
                    _react2.default.createElement('textarea', _extends({}, rest, { className: 'form-element-input', onChange: _this.onChange, value: value || initialValue }))
                ),
                message && _react2.default.createElement(
                    'span',
                    { className: 'form-element-message' },
                    message
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return TextArea;
}(_TextInput2.TextInput);

TextArea.defaultProps = {
    autoComplete: 'off',
    rows: 8
};

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/undraw_hiring_cyhs.36c688d6.svg";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/undraw_wallet_aym5.3fadf737.svg";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/undraw_QA_engineers_dg5p.75b2d092.svg";

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Home.2738a130.js